// ToggleButton.js
import React from "react";
import "./ToggleSlider.css";

const ToggleButton = ({ checked, onChange }) => {
  return (
    <label className="codebook-toggle-switch">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="codebook-toggle-slider" />
    </label>
  );
};

export default ToggleButton;
